import { useContext, useEffect, useState } from "react";
import "../../../routes/Admin/admin.styles.scss";
import FormModal from "../../../components/customForm/formModal.component";
import Layout from "../../../components/Layout";
import AdminGeneralTable from "../AdminGeneralTable";
import {
  useGetAdventureOptionsQuery,
  useGetCountriesOptionsQuery,
  useGetProgrammesQuery,
} from "../../../apiCaller/apis/getApi";
import AdminSectionTitle from "../AdminSectionTitle";
import { ProgrammeAdminTableColumns } from "../../../utils/columns";
import {
  CountriesOptionMapper,
  ProgrammeMapper,
} from "../../../utils/DataMapper";
import { useDeleteProgrammeMutation } from "../../../apiCaller/apis/deleteApi";
import { toast } from "react-toastify";
import {
  AddProgrammeDisplayImageSchema,
  AddProgrammeDisplayImageUiSchema,
  AddProgrammeSchema,
  AddProgrammeUiSchema,
  AddProgrammePriceSchema,
  AddProgrammePriceUiSchema,
  ManageProgrammeAdventuresSchema,
  ManageProgrammeAdventuresUiSchema,
} from "../../../utils/forms";
import { GetTableListAPI } from "../../../apiCaller/getAPIsCaller";
import {
  useAddProgrammeMutation,
  useAddProgrammeAdventuresMutation,
} from "../../../apiCaller/apis/postApi";
import {
  useAddProgrammeImageMutation,
  useUpdateProgrammeMutation,
  useUpdateProgrammePricesMutation,
} from "../../../apiCaller/apis/updateApi";
import { useDeleteProgrammeAdventuresMutation } from "../../../apiCaller/apis/deleteApi";

const AdminProgrammes = () => {
  const {
    data: countries,
    error,
    isLoading,
    isFetching,
  } = GetTableListAPI({}, useGetCountriesOptionsQuery);
  const {
    data: adventureOptions,
    error: destinationOptionsError,
    isLoading: destinationOptionsIsLoading,
    isFetching: destinationOptionsIsFetching,
  } = GetTableListAPI({}, useGetAdventureOptionsQuery);
  const [
    deleteProgramme,
    {
      data: response,
      isLoading: deleteLoading,
      isError: postIsError,
      error: postError,
      isSuccess,
    },
  ] = useDeleteProgrammeMutation({});
  const [
    addProgramme,
    {
      data: addProgrammeResponse,
      isLoading: addProgrammeLoading,
      isError: addProgrammeIsError,
      error: addProgrammeError,
      isSuccess: addProgrammeIsSuccess,
    },
  ] = useAddProgrammeMutation({});

  const [
    updateProgramme,
    {
      data: updateProgrammeResponse,
      isLoading: updateProgrammeLoading,
      isError: updateProgrammeIsError,
      error: updateProgrammeError,
      isSuccess: updateProgrammeIsSuccess,
    },
  ] = useUpdateProgrammeMutation({});

  const [
    updateProgrammePrices,
    {
      data: updateProgrammePricesResponse,
      isLoading: updateProgrammePricesLoading,
      isError: updateProgrammePricesIsError,
      error: updateProgrammePricesError,
      isSuccess: updateProgrammePricesIsSuccess,
    },
  ] = useUpdateProgrammePricesMutation({});

  const [
    addProgrammeImage,
    {
      data: addProgrammeImagenResponse,
      isLoading: addProgrammeImageLoading,
      isError: addProgrammeImageIsError,
      error: addProgrammeImageError,
      isSuccess: addProgrammeImageIsSuccess,
    },
  ] = useAddProgrammeImageMutation({});

  const [
    addProgrammeAdventures,
    {
      data: addAdventuresResponse,
      isLoading: addAdventuresLoading,
      isError: addAdventuresIsError,
      error: addAdventuresError,
      isSuccess: addAdventuresIsSuccess,
    },
  ] = useAddProgrammeAdventuresMutation({});

  const [
    deleteProgrammeAdventures,
    {
      data: deleteAdventuresResponse,
      isLoading: deleteAdventuresLoading,
      isError: deleteAdventuresIsError,
      error: deleteAdventuresError,
      isSuccess: deleteAdventuresIsSuccess,
    },
  ] = useDeleteProgrammeAdventuresMutation({});

  const [countriesLookup, setCountriesLookup] = useState([]);

  const handleDelete = async (id, close) => {
    const result = await deleteProgramme(id);
    if (result) {
      if (result.data.IsSuccess) {
        toast("Programme deleted successful");
      } else {
        toast("Action was unsuccessful");
      }
      close();
    }
  };

  const handleAddProgramme = async (data, close) => {
    const uploadData = {
      name: data.name,
      description: data.description,
      duration: data.duration,
      durationUnits: data.durationUnits,
      startDate: data.startDate,
      endDate: data.endDate,
      // adventureIds removed - now managed through separate adventure management interface
      paymentPlan: data.paymentPlan,
      priceTiers: 1,
      price: [
        {
          name: "tier 1",
          description: "tier 1",
          priceGroups: data.priceGroups,
        },
      ],
      bookingLink: data.bookingLink,
    };

    const result = await addProgramme(uploadData);
    if (result) {
      console.log(result?.data?.IsSuccess);
      if (
        result?.data?.IsSuccess !== undefined &&
        result?.data?.IsSuccess !== false
      ) {
        toast("Programme Added successful");
        close();
      } else {
        toast("An error occured");
      }
    }
  };

  const handleUpdate = async (data, close) => {
    const result = await updateProgramme({
      programmeId: data.id,
      data: {
        name: data.name,
        description: data.description,
        duration: data.duration,
        durationUnits: data.durationUnits,
        startDate: data.startDate,
        endDate: data.endDate,
        // adventureIds removed - now managed through separate adventure management interface
        paymentPlan: data.paymentPlan,
        bookingLink: data.bookingLink,
        priceTiers: 1,
        price: [
          {
            name: "tier 1",
            description: "tier 1",
            priceGroups: data.priceGroups,
          },
        ],
      },
    });
    if (result) {
      if (
        result?.data?.IsSuccess !== undefined &&
        result?.data?.IsSuccess !== false
      ) {
        toast("Programme Updated successful");
        close();
      } else {
        toast("An error occured");
      }
    }
  };

  const handlePriceUpdate = async (data, close) => {
    console.log(data);
    const result = await updateProgrammePrices(data);
    if (result) {
      if (
        result?.data?.IsSuccess !== undefined &&
        result?.data?.IsSuccess !== false
      ) {
        toast("Programme Updated successful");
        close();
      } else {
        toast("An error occured");
      }
    }
  };

  const handleImageUpload = async (data, close) => {
    console.log(data);
    const result = await addProgrammeImage(data);
    if (result) {
      console.log(result?.data?.IsSuccess);
      if (
        result?.data?.IsSuccess !== undefined &&
        result?.data?.IsSuccess !== false
      ) {
        toast("Programme Image Added successful");
        close();
      } else {
        toast("An error occured");
      }
    }
  };

  const handleAdventureUpdate = async (data, close) => {
    console.log("Adventure management data:", data);

    try {
      let deleteResult = null;
      let addResult = null;

      // Handle deletions first if there are adventures marked for deletion
      if (
        data.adventuresMarkedForDeletion &&
        data.adventuresMarkedForDeletion.length > 0
      ) {
        console.log("Deleting adventures:", data.adventuresMarkedForDeletion);
        deleteResult = await deleteProgrammeAdventures(
          data.adventuresMarkedForDeletion
        );

        if (deleteResult?.error) {
          toast("Error deleting adventures");
          return;
        }
      }

      // Handle additions if there are new adventures to add
      if (data.adventuresToAdd && data.adventuresToAdd.length > 0) {
        console.log("Adding adventures:", data.adventuresToAdd);
        addResult = await addProgrammeAdventures({
          programmeId: data.programmeId,
          adventureIds: data.adventuresToAdd,
        });

        if (addResult?.error) {
          toast("Error adding adventures");
          return;
        }
      }

      // Check if any operations were performed
      if (deleteResult || addResult) {
        // Check success status
        const deleteSuccess =
          !deleteResult || deleteResult?.data?.IsSuccess !== false;
        const addSuccess = !addResult || addResult?.data?.IsSuccess !== false;

        if (deleteSuccess && addSuccess) {
          toast("Adventure management completed successfully!");
          close();
        } else {
          toast("Some operations failed. Please check and try again.");
        }
      } else {
        toast("No changes detected");
        close();
      }
    } catch (error) {
      console.error("Error in adventure management:", error);
      toast("An error occurred during adventure management");
    }
  };

  useEffect(() => {
    if (CountriesOptionMapper !== undefined && countries !== undefined) {
      setCountriesLookup(CountriesOptionMapper(countries));
    }
  }, [countries]);
  return (
    <Layout>
      <div className="mx-10">
        <div className="admin__header">{/* <Navigation/> */}</div>
        <main>
          <div>
            <AdminSectionTitle
              title={"Programmes"}
              subTitle={"A list of Programmes"}
              schema={AddProgrammeSchema}
              uischema={AddProgrammeUiSchema(adventureOptions?.Value)}
              addButtonTitle={"Programme"}
              addFormTitle={"Add Programme"}
              addFormSubtitle={"Adding Programme"}
              handleSubmit={handleAddProgramme}
            />
          </div>

          <div className="admin__content-table">
            <AdminGeneralTable
              caller={useGetProgrammesQuery}
              tableInfo={{
                actionButtons: ["view"],
                toRoute: "/schedules",
                actionBtns: ["add-schedules"],
                hasMore: false,
                noActions: true,
                columns: ProgrammeAdminTableColumns,
              }}
              deleteFunc={handleDelete}
              mapper={ProgrammeMapper}
              deleteLoading={deleteLoading}
              updateSchema={AddProgrammeSchema}
              updateUiSchema={AddProgrammeUiSchema(adventureOptions?.Value)}
              updateSubmitFunc={handleUpdate}
              route={"Programme"}
              handleImageUpload={handleImageUpload}
              handlePriceUpdate={handlePriceUpdate}
              imageSchema={AddProgrammeDisplayImageSchema}
              imageUiSchema={AddProgrammeDisplayImageUiSchema}
              priceSchema={AddProgrammePriceSchema}
              priceUiSchema={AddProgrammePriceUiSchema}
              allowPricieTiering={true}
              allowImageUpload={true}
              allowAdventureManagement={true}
              adventureSchema={ManageProgrammeAdventuresSchema}
              adventureUiSchema={ManageProgrammeAdventuresUiSchema(
                adventureOptions?.Value
              )}
              handleAdventureUpdate={handleAdventureUpdate}
              title={"Programme"}
              subtitle={"Programme"}
            />
          </div>
        </main>
        <FormModal />
      </div>
    </Layout>
  );
};

export default AdminProgrammes;
